import ActionBillTable from "pages/creditBills/components/Table";
import Button from "pages/_components/Button";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedAmount from "pages/_components/FormattedAmount";
import I18n from "pages/_components/I18n";
import { TransactionSign } from "pages/_components/TransactionCard";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { bool, func } from "prop-types";
import React, { useContext, useState } from "react";
import { formatAction } from "util/creditBills";

export const ActionFCEMSummaryBody = ({ isDesktop, isFinished, showMoreData, setShowMoreData }) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;
    const { actionI18n } = formatAction(data?.action);

    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    const { motive = "", invoiceList, responseList, tabOption } = data;
    const totalAmount = invoiceList.reduce((sum, item) => sum + item.saldoAceptado, 0);
    const hasMotive = !!motive;

    const invoiceListWitResponse = responseList?.map((item) => {
        const bill = invoiceList.find(
            (element) => item.invoice.facturaId.numeroComprobante === element.facturaId.numeroComprobante,
        );
        return { ...bill, code: item.code, message: item.message, error: item.message };
    });

    return (
        <div className="ticket__body echeq-massive-emit">
            <div className="ticket-header-info">
                <CustomData
                    dataClass={`amount tag ${isFinished ? "tag-echeq-character" : "tag-warning"}`}
                    titleText="creditBill.amount.label"
                    titleTextType="I18N"
                    valueText={<FormattedAmount className="data-label" currency="ARS" quantity={totalAmount} />}
                />
            </div>
            <div className="view-more-data-button" id="element-to-ignore">
                <div className="ticket__divider inside-ticket__body">
                    <div className="ticket__notch ticket__notch--left"> </div>
                    <div className="ticket__notch ticket__notch--right"> </div>
                </div>
                <Button
                    aria-expanded={showMoreData ? "true" : "false"}
                    className="more-button"
                    label={buttonLabel}
                    bsStyle="link"
                    onClick={handleSeeMoreData}
                    image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                />
            </div>
            <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                {invoiceList.length > 1 ? (
                    <>
                        <I18n id="creditBill.lot.title" component="h2" />
                        <ActionBillTable
                            isDesktop={isDesktop}
                            tabOption={tabOption}
                            bills={invoiceListWitResponse || invoiceList}
                            isFinished={isFinished}
                            hideButton
                        />
                    </>
                ) : (
                    <>
                        <I18n id="creditBill.aditionalData.label" component="h2" />
                        {invoiceList.map((bill) => {
                            if (hasMotive) {
                                return (
                                    <>
                                        <CustomData
                                            titleText={`creditBill.${actionI18n}.motive.label`}
                                            titleTextType="I18N"
                                            valueText={motive}
                                        />
                                        <CustomData
                                            titleText="credit.bills.cuit.emitter"
                                            titleTextType="I18N"
                                            valueText={bill.facturaId.cuitEmisor}
                                        />
                                        <CustomData
                                            titleText="credit.bills.cuit.debtor"
                                            titleTextType="I18N"
                                            valueText={bill.cuitComprador}
                                        />
                                        <CustomData
                                            titleText="creditBill.issuerCuit.tag"
                                            titleTextType="I18N"
                                            valueText={bill.razonSocialEmisor}
                                        />
                                        <CustomData
                                            titleText="credit.bills.debtor"
                                            titleTextType="I18N"
                                            valueText={bill.razonSocialComprador}
                                        />
                                        <CustomData
                                            titleText="creditBill.issueDateRange.label"
                                            titleTextType="I18N"
                                            valueText={bill.fechaEmision}
                                            valueTextType="DATE"
                                        />
                                        <CustomData
                                            titleText="credit.bills.cuit.holder"
                                            titleTextType="I18N"
                                            valueText={bill.cuitTenedor}
                                        />
                                        <CustomData
                                            titleText="creditBill.paymentDueDateRange.label"
                                            titleTextType="I18N"
                                            valueText={bill.fechaVencimientoPago}
                                            valueTextType="DATE"
                                        />
                                        <CustomData
                                            titleText="creditBill.holderCuit.tag"
                                            titleTextType="I18N"
                                            valueText={bill.razonSocialTenedor}
                                        />
                                    </>
                                );
                            }

                            return (
                                <>
                                    <CustomData
                                        titleText="credit.bills.cuit.debtor"
                                        titleTextType="I18N"
                                        valueText={bill.cuitComprador}
                                    />
                                    <CustomData
                                        titleText="credit.bills.cuit.emitter"
                                        titleTextType="I18N"
                                        valueText={bill.facturaId.cuitEmisor}
                                    />
                                    <CustomData
                                        titleText="creditBill.issuerCuit.tag"
                                        titleTextType="I18N"
                                        valueText={bill.razonSocialEmisor}
                                    />
                                    <CustomData
                                        titleText="credit.bills.debtor"
                                        titleTextType="I18N"
                                        valueText={bill.razonSocialComprador}
                                    />
                                    <CustomData
                                        titleText="credit.bills.cuit.holder"
                                        titleTextType="I18N"
                                        valueText={bill.cuitTenedor}
                                    />
                                    <CustomData
                                        titleText="creditBill.issueDateRange.label"
                                        titleTextType="I18N"
                                        valueText={bill.fechaEmision}
                                        valueTextType="DATE"
                                    />
                                    <CustomData
                                        titleText="creditBill.holderCuit.tag"
                                        titleTextType="I18N"
                                        valueText={bill.razonSocialTenedor}
                                    />

                                    <CustomData
                                        titleText="creditBill.paymentDueDateRange.label"
                                        titleTextType="I18N"
                                        valueText={bill.fechaVencimientoPago}
                                        valueTextType="DATE"
                                    />
                                </>
                            );
                        })}
                    </>
                )}
                <TransactionSign
                    isDesktop={isDesktop}
                    hasVaucher
                    creationTime
                    isSmall
                    noDate={!isFinished}
                    showMoreData={showMoreData}
                />
            </div>
        </div>
    );
};

ActionFCEMSummaryBody.propTypes = {
    isDesktop: bool.isRequired,
    isFinished: bool,
    showMoreData: bool,
    setShowMoreData: func,
};

ActionFCEMSummaryBody.defaultProps = {
    isFinished: false,
    showMoreData: false,
    setShowMoreData: () => {},
};

export default ActionFCEMSummaryBody;
